import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const UserFollowingItem = ({
  friend,
  user,
  profile,
  showModal,
  setShowModal,
  setUnfollowedUser,
  setShowUnfollowUser,
}) => {
  return (
    <Fragment>
      {friend.role === "innovator" && (
        <div className="user-section-alt">
          <div className="friends-user-container">
            <Link to={`/${friend.channelid}`}>
              <div className="friend-user-avi-container">
                <div className="avi-color-border green">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${friend.avatar}`}
                    className="friend-user-avi"
                    alt="avatar"
                  />
                </div>
              </div>
            </Link>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="green name-font">{friend.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {friend.firstname} {friend.lastname}
                  </li>
                  <li className="user-online-item">{friend.jobtitle}</li>
                  <li className="user-online-item">
                    {friend.location.city}, {friend.location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {user.user === profile.user && (
            <div className="friends-buttons-container">
              <div className="friend-button-container">
                <button
                  onClick={() => {
                    setUnfollowedUser({
                      channelid: friend.channelid,
                      role: friend.role,
                      avatar: friend.avatar,
                      firstname: friend.firstname,
                      lastname: friend.lastname,
                      jobtitle: friend.jobtitle,
                      location: friend.location,
                    });
                    setShowUnfollowUser({ request: true, confirm: false });
                  }}
                  className="friend-button background-green"
                >
                  <i className="fas fa-user-minus mx-5"></i>
                  Unfollow
                </button>
              </div>
              {user.channelid === profile.channelid && (
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v fa-lg ellipsis-pos green"
                ></i>
              )}
              {showModal && (
                <div className="modal">
                  <ul className="modal-items">
                    <li className="modal-item">
                      <i className="fas fa-flag mx-5 white"></i>
                      Report
                    </li>
                    <li className="modal-item">
                      <i className="fas fa-ban mx-5 white"></i>
                      Block
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {friend.role === "mentor" && (
        <div className="user-section-alt">
          <div className="friends-user-container">
            <Link to={`/${friend.channelid}`}>
              <div className="friend-user-avi-container">
                <div className="avi-color-border red">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${friend.avatar}`}
                    className="friend-user-avi"
                    alt="red-avatar"
                  />
                </div>
              </div>
            </Link>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="red name-font">{friend.channelid}</span>
                  </li>
                  <li className="user-online-item">
                    {friend.firstname} {friend.lastname}
                  </li>
                  <li className="user-online-item">{friend.jobtitle}</li>
                  <li className="user-online-item">
                    {friend.location.city}, {friend.location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {user.user === profile.user && (
            <div className="friends-buttons-container">
              <div className="friend-button-container">
                <button
                  onClick={() => {
                    setUnfollowedUser({
                      channelid: friend.channelid,
                      role: friend.role,
                      avatar: friend.avatar,
                      firstname: friend.firstname,
                      lastname: friend.lastname,
                      jobtitle: friend.jobtitle,
                      location: friend.location,
                    });
                    setShowUnfollowUser({ request: true, confirm: false });
                  }}
                  className="friend-button background-red"
                >
                  <i className="fas fa-user-minus mx-5"></i>
                  Unfollow
                </button>
              </div>
              {user.channelid === profile.channelid && (
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v fa-lg ellipsis-pos red"
                ></i>
              )}
              {showModal && (
                <div className="modal">
                  <ul className="modal-items">
                    <li className="modal-item">
                      <i className="fas fa-flag mx-5 white"></i>
                      Report
                    </li>
                    <li className="modal-item">
                      <i className="fas fa-ban mx-5 white"></i>
                      Block
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {friend.role === "employer" && (
        <div className="user-section-alt">
          <div className="friends-user-container">
            <Link to={`/${friend.channelid}`}>
              <div className="friend-user-avi-container">
                <div className="avi-color-border blue">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${friend.avatar}`}
                    className="friend-user-avi"
                    alt="blue-avatar"
                  />
                </div>
              </div>
            </Link>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span className="blue name-font">{friend.companyname}</span>
                  </li>
                  <li className="user-online-item">{friend.channelid}</li>
                  <li className="user-online-item">
                    {friend.firstname} {friend.lastname}
                  </li>
                  <li className="user-online-item">
                    {friend.location.city}, {friend.location.state}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {user.user === profile.user && (
            <div className="friends-buttons-container">
              <div className="friend-button-container">
                <button
                  onClick={() => {
                    setUnfollowedUser({
                      channelid: friend.channelid,
                      role: friend.role,
                      avatar: friend.avatar,
                      firstname: friend.firstname,
                      lastname: friend.lastname,
                      jobtitle: friend.jobtitle,
                      location: friend.location,
                    });
                    setShowUnfollowUser({ request: true, confirm: false });
                  }}
                  className="friend-button background-blue"
                >
                  <i className="fas fa-user-minus mx-5"></i>
                  Unfollow
                </button>
              </div>
              {user.channelid === profile.channelid && (
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v fa-lg ellipsis-pos blue"
                ></i>
              )}
              {showModal && (
                <div className="modal">
                  <ul className="modal-items">
                    <li className="modal-item">
                      <i className="fas fa-flag mx-5 white"></i>
                      Report
                    </li>
                    <li className="modal-item">
                      <i className="fas fa-ban mx-5 white"></i>
                      Block
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default UserFollowingItem;
